/**
 * Generates a random GUID (Globally Unique Identifier) in the format 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.
 * 
 * @function
 * @returns {string} A randomly generated GUID string.
 * 
 * @example
 * const guid = generateGUID();
 * // Example output: '3f2504e0-4f89-41d3-9a0c-0305e82c3301'
 */
const generateGUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
  const randomValue = Math.floor(Math.random() * 16);
  const variantBits = 4;
  const variantOffset = 8;

  if (char === 'x') {
    return randomValue.toString(16);
  }

  const variantValue = (randomValue % variantBits) + variantOffset;
  return variantValue.toString(16);
});

export default generateGUID;